const durationQuestion = {
  type: 'radiogroup',
  name: 'duration',
  title: 'How long have you been focused on getting in shape?',
  description: "This helps us understand where you’re starting from.",
  choices: [
    "0-6 months",
    "6-12 months",
    "1-3 years",
    "3+ years",
  ],
  isRequired: true,
}

export {
  durationQuestion,
}